import script from "./OperatorApplicationMainMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationMainMenu.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationMainMenu.vue?vue&type=style&index=0&id=62d6300c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62d6300c"]])

export default __exports__